(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 7330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return __webpack_require__(592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageOuterContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1953);


function PageOuterContainer(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        children: children
    });
}


/***/ }),

/***/ 3847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9630);
/* harmony import */ var _styles_PageHeader_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9098);
/* harmony import */ var _styles_PageHeader_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_PageHeader_module_css__WEBPACK_IMPORTED_MODULE_2__);



function PageHeader(param) {
    let { text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "h1",
        component: "h1",
        color: "primary",
        gutterBottom: true,
        className: (_styles_PageHeader_module_css__WEBPACK_IMPORTED_MODULE_2___default().pageHeader),
        children: text
    });
}


/***/ }),

/***/ 592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Features; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/layouts/PageContainer.js
var PageContainer = __webpack_require__(4615);
// EXTERNAL MODULE: ./components/shared/PageHeader.js
var PageHeader = __webpack_require__(3847);
// EXTERNAL MODULE: ./components/layouts/PageOuterContainer.js
var PageOuterContainer = __webpack_require__(5171);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./constants/seo.json
var seo = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./styles/Features.module.css
var Features_module = __webpack_require__(8860);
var Features_module_default = /*#__PURE__*/__webpack_require__.n(Features_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(918);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardMedia/cardMediaClasses.js

function getCardMediaUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardMedia', slot);
}
const cardMediaClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardMedia', ['root', 'media', 'img']);
/* harmony default export */ var CardMedia_cardMediaClasses = ((/* unused pure expression or super */ null && (cardMediaClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardMedia/CardMedia.js


const CardMedia_excluded = ["children", "className", "component", "image", "src", "style"];










const CardMedia_useUtilityClasses = ownerState => {
  const {
    classes,
    isMediaComponent,
    isImageComponent
  } = ownerState;
  const slots = {
    root: ['root', isMediaComponent && 'media', isImageComponent && 'img']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardMediaUtilityClass, classes);
};

const CardMediaRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardMedia',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      isMediaComponent,
      isImageComponent
    } = ownerState;
    return [styles.root, isMediaComponent && styles.media, isImageComponent && styles.img];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}, ownerState.isMediaComponent && {
  width: '100%'
}, ownerState.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: 'cover'
}));
const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
const IMAGE_COMPONENTS = ['picture', 'img'];
const CardMedia = /*#__PURE__*/react.forwardRef(function CardMedia(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardMedia'
  });

  const {
    children,
    className,
    component = 'div',
    image,
    src,
    style
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, CardMedia_excluded);

  const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
  const composedStyle = !isMediaComponent && image ? (0,esm_extends/* default */.Z)({
    backgroundImage: `url("${image}")`
  }, style) : style;

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    isMediaComponent,
    isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
  });

  const classes = CardMedia_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMediaRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    as: component,
    role: !isMediaComponent && image ? 'img' : undefined,
    ref: ref,
    style: composedStyle,
    ownerState: ownerState,
    src: isMediaComponent ? image || src : undefined
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardMedia_CardMedia = (CardMedia);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardHeader/cardHeaderClasses.js

function getCardHeaderUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardHeader', slot);
}
const cardHeaderClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardHeader', ['root', 'avatar', 'action', 'content', 'title', 'subheader']);
/* harmony default export */ var CardHeader_cardHeaderClasses = (cardHeaderClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js


const CardHeader_excluded = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"];











const CardHeader_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    avatar: ['avatar'],
    action: ['action'],
    content: ['content'],
    title: ['title'],
    subheader: ['subheader']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardHeaderUtilityClass, classes);
};

const CardHeaderRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardHeader',
  slot: 'Root',
  overridesResolver: (props, styles) => (0,esm_extends/* default */.Z)({
    [`& .${CardHeader_cardHeaderClasses.title}`]: styles.title,
    [`& .${CardHeader_cardHeaderClasses.subheader}`]: styles.subheader
  }, styles.root)
})({
  display: 'flex',
  alignItems: 'center',
  padding: 16
});
const CardHeaderAvatar = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardHeader',
  slot: 'Avatar',
  overridesResolver: (props, styles) => styles.avatar
})({
  display: 'flex',
  flex: '0 0 auto',
  marginRight: 16
});
const CardHeaderAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardHeader',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  flex: '0 0 auto',
  alignSelf: 'flex-start',
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
});
const CardHeaderContent = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardHeader',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})({
  flex: '1 1 auto'
});
const CardHeader = /*#__PURE__*/react.forwardRef(function CardHeader(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardHeader'
  });

  const {
    action,
    avatar,
    className,
    component = 'div',
    disableTypography = false,
    subheader: subheaderProp,
    subheaderTypographyProps,
    title: titleProp,
    titleTypographyProps
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, CardHeader_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    disableTypography
  });

  const classes = CardHeader_useUtilityClasses(ownerState);
  let title = titleProp;

  if (title != null && title.type !== Typography/* default */.Z && !disableTypography) {
    title = /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps, {
      children: title
    }));
  }

  let subheader = subheaderProp;

  if (subheader != null && subheader.type !== Typography/* default */.Z && !disableTypography) {
    subheader = /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "text.secondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps, {
      children: subheader
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CardHeaderRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    as: component,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [avatar && /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderAvatar, {
      className: classes.avatar,
      ownerState: ownerState,
      children: avatar
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardHeaderContent, {
      className: classes.content,
      ownerState: ownerState,
      children: [title, subheader]
    }), action && /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderAction, {
      className: classes.action,
      ownerState: ownerState,
      children: action
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardHeader_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardContent/cardContentClasses.js

function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js


const CardContent_excluded = ["className", "component"];









const CardContent_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};

const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, CardContent_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = CardContent_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);
;// CONCATENATED MODULE: ./components/shared/FeatureCardItem.js




const FeatureCardItem = (param)=>{
    let { image , name , text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card, {
        elevation: 2,
        sx: {
            maxWidth: 300
        },
        className: (Features_module_default()).featureItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia, {
                component: "img",
                alt: name,
                height: "150",
                width: "150",
                image: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader_CardHeader, {
                title: name,
                className: (Features_module_default()).featureItemHeader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent, {
                children: text
            })
        ]
    });
};
/* harmony default export */ var shared_FeatureCardItem = (FeatureCardItem);

;// CONCATENATED MODULE: ./components/shared/FeatureLargeItem.js





const FeatureLargeItem = (param)=>{
    let { image , subject , primaryText , secondaryText , direction  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (Features_module_default()).featureLargeItem,
        style: {
            flexDirection: direction === "right" ? "row-reverse" : "row"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (Features_module_default()).largeFeatureItemImageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: subject,
                    className: (Features_module_default()).largeItemImg
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (Features_module_default()).largeFeatureItemText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        component: "h4",
                        gutterBottom: true,
                        children: subject
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (Features_module_default()).text,
                        children: primaryText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (Features_module_default()).text,
                        children: secondaryText
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_FeatureLargeItem = (FeatureLargeItem);

;// CONCATENATED MODULE: ./pages/features.js











const features = [
    {
        image: "/images/emergency-groups.png",
        subject: "Emergency specific groups",
        primaryText: "Set-up via Web Portal. Use a CSV file to upload and create multiple groups quickly. Sync your groups via LDAP based Active Directory.",
        secondaryText: "Pre-planned group members may belong to different organizations (Fire, Police, EMS etc.).",
        direction: "left"
    },
    {
        image: "/images/flow-animation-image.png",
        subject: "Blast Dial capability",
        primaryText: "Trigger the dial-out based on incoming phone call, click on a Web Portal, closure of a relay, (optional) or at a scheduled time.",
        secondaryText: "Multiple first responders are called in parallel - reduces the overall time required to contact them.",
        direction: "right"
    },
    {
        image: "/images/find-you-capability.png",
        subject: "Find-me capability",
        primaryText: "System dials up to 4 phone numbers and sends SMS and emails when locating an individual recipient. Improves the probability of reaching an individual first responder.",
        secondaryText: "",
        direction: "left"
    },
    {
        image: "/images/secure-conference.png",
        subject: "Secure audio conferencing",
        primaryText: "Allow First Responders to join the conference only after they enter a security key.",
        secondaryText: "Prevents unauthorized participants to enter an emergency conference.",
        direction: "right"
    },
    {
        image: "/images/call-log.png",
        subject: "Call logging",
        primaryText: "Record all InstaConference calls and capture call logs with time stamps.",
        secondaryText: "Useful for post-event analysis.",
        direction: "left"
    },
    {
        image: "/images/send-sms-emails.png",
        subject: "Send SMS, Email and Pager messages",
        primaryText: "Set-up via Web Portal. Send SMS, Email and Pager blasts with or without accompanying voice calls. Helps in disseminating emergency related information in multiple ways.",
        secondaryText: "",
        direction: "right"
    }
];
function Features() {
    const meta = seo.features;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageOuterContainer/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: meta.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: meta.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: meta.keywords
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        text: "Features"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (Features_module_default()).container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                mt: 3,
                                mb: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_FeatureCardItem, {
                                        text: "Send calls to any landline or cellular phone.",
                                        image: "/images/flexible-emergency-calling.png",
                                        name: "Flexible Calling"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_FeatureCardItem, {
                                        text: "Select communication medium to be used for message delivery (Voice only, SMS only, Email only or any combination of the above.)",
                                        image: "/images/message-channels.png",
                                        name: "Message Channels"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_FeatureCardItem, {
                                        text: "Use built-in ’Find-me’ capability to increase the probability of finding a recipient.",
                                        image: "/images/location-tracking.png",
                                        name: "Find Me"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_FeatureCardItem, {
                                        text: "Send Caller-ID of your choice that can be used by cell phones to display associated caller name (e.g., 'Fire Chief') - leading to higher percentage of recipients picking up the phone.",
                                        image: "/images/caller-id.png",
                                        name: "Caller ID Optimization"
                                    })
                                ]
                            }),
                            features.map((feature, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_FeatureLargeItem, {
                                    image: feature.image,
                                    subject: feature.subject,
                                    primaryText: feature.primaryText,
                                    secondaryText: feature.secondaryText,
                                    direction: feature.direction
                                }, index);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Features_container__auZzO","featureItem":"Features_featureItem__KW79N","featureItemHeader":"Features_featureItemHeader__A3shj","featureLargeItem":"Features_featureLargeItem__c_g3k","largeItemImg":"Features_largeItemImg__t3D7Y","largeFeatureItemText":"Features_largeFeatureItemText___WF0g","largeFeatureItemImageContainer":"Features_largeFeatureItemImageContainer__cxcZC","text":"Features_text__L_Gzh"};

/***/ }),

/***/ 9098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PageHeader_pageHeader__zGFYE"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 948:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"home":{"title":"InstaConference for your emergency needs","description":"Our software solution offers emergency conference calls for your business needs.","keywords":"emergency conference, first responders, critical infrastructure, emergency communication, conference call software"},"features":{"title":"Features","description":"Discover the advanced features of our emergency conference software, including reliable call connections, easy call management and more.","keywords":"emergency conference features, call management, reliable connections"},"pricing":{"title":"Pricing","description":"Explore our flexible pricing options for emergency conference calls, including pay-per-use and monthly plans.","keywords":"emergency conference pricing, pay-per-use, monthly plans"},"contacts":{"title":"Contact","description":"Get in touch with our team for any questions or support needs about our emergency conference software.","keywords":"emergency conference contact, support, customer service"},"support":{"title":"Support","description":"Find the help and resources you need to successfully use our emergency conference software.","keywords":"emergency conference support, user guide, FAQ"},"signup":{"title":"Sign Up","description":"Easily sign up for our emergency conference software and start using it for your business needs.","keywords":"emergency conference signup, registration, account creation"},"terms-of-service":{"title":"Terms of Service","description":"Review our terms of service for using our emergency conference software.","keywords":"emergency conference terms of service, legal, user agreement"},"privacy-policy":{"title":"Privacy Policy","description":"Understand how we handle and protect your personal information when using our emergency conference software.","keywords":"emergency conference privacy policy, data protection, user privacy"},"press-releases":{"title":"Press Releases","description":"Read the latest press releases about our emergency conference software.","keywords":"emergency conference press releases, news, announcements"},"xop-life-line-for-rural-fire-chiefs-in-emergency-situation":{"title":"XOP Life Line for Rural Fire Chiefs in Emergency Situation","description":"XOP Networks, Inc., a manufacturer of Emergency Conference Bridges, announced today that it has deployed its Universal Emergency Conference Bridge (UECB) at a large rural fire department in the Midwest.","keywords":"emergency conference, first responders, critical infrastructure, emergency communication, conference call software"},"about-us":{"title":"About Us","description":"Learn more about our company and the team behind our emergency conference software.","keywords":"emergency conference about us, company, team"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(7330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);